<template>
	<div style="width:100%; max-width:1300px; margin:0 auto; margin-top:0px;max-height: 400px;overflow-y: auto;">
	<style type="text/css">
		p{ margin-bottom:20px; line-height:24px;}
	</style>
	</div>
</template>

<script>
export default {
  name: "privacy-en-lib",
  components: {
  }
};
</script>
